import { Outlet, useParams } from "react-router-dom";
import { AppRouteProps } from "src/components/router/AppRoute";
import CreateTab, { registerWrapperComponent } from "src/hooks/useTab";
import { wrapRoutes } from "src/components/router/AuthWrapper";
import PatientCareDefinition from "./patient-care-add";
import DietProceduresCreate from "./diet-procedures";
import SurgeryList from "../nurse/surgery/pages/list";
import { useTranslate } from "src/locales";
import React from "react";

// Wrapper component'leri başlangıçta register et
registerWrapperComponent('patient/patient-care-add', () => React.createElement(PatientCareDefinition));
registerWrapperComponent('patient/patient-care-guide', () => React.createElement(PatientCareDefinition));
registerWrapperComponent('patient/diet-procedures', () => React.createElement(DietProceduresCreate));
registerWrapperComponent('patient/nurse-application-screen', () => React.createElement(SurgeryList));

//MPOGLU;443876;19022025S
export const patientRoutes: AppRouteProps[] = [
  {
    path: "patient",
    element: (
      <PatientLayout>
        <Outlet />
      </PatientLayout>
    ),
    children: wrapRoutes([
      { path: 'patient-care-add/:id', element: <PatientTab title="Hasta Bakım Ekleme" element={PatientCareDefinition} path="patient/patient-care-add" />, role: "frmPatientCareAdd" },
      { path: 'patient-care-guide/:id', element: <PatientTab title="Hasta Klavuz Ekleme" element={PatientCareDefinition} path="patient/patient-care-guide" />, role: "frmPatientCareGuide" },
      { path: 'diet-procedures/:id', element: <PatientTab title="patient-diet-procedures.add-popup.diet-operations" element={DietProceduresCreate} path="patient/diet-procedures" />, role: "frmDietProcedures" },
      { path: 'nurse-application-screen/:id?', element: <PatientTab title="nurse-surgery-procedure.title" element={SurgeryList} path="patient/nurse-application-screen" />, role: "actNursingProcess" }
    ]),
  },
];

function PatientLayout(props: any) {
  return <>{props.children}</>;
}

function PatientTab({ title, element: Element, path }: { title: string; element: any; path: string }) {
  const { id } = useParams();
  const { t } = useTranslate();
  const patientId = id ? parseInt(id) : null;



  return <CreateTab title={t(title)} element={<Element patientId={patientId} />} patientId={patientId} path={path} />;
}